import { motion } from "framer-motion";
import { PILLARS } from "../data/site";
import { revealUp, staggerParent, viewportOnce, EASE } from "../lib/motion";

const BorderDraw = ({ delay }) => {
  const line = (extra, initial, animate) => (
    <motion.span
      className={`absolute bg-labyellow ${extra}`}
      initial={initial}
      whileInView={animate}
      viewport={viewportOnce}
      transition={{ duration: 0.5, ease: EASE, delay }}
    />
  );
  return (
    <>
      {line("left-0 top-0 h-px w-full origin-left", { scaleX: 0 }, { scaleX: 1 })}
      {line("right-0 top-0 h-full w-px origin-top", { scaleY: 0 }, { scaleY: 1 })}
      {line("left-0 bottom-0 h-px w-full origin-right", { scaleX: 0 }, { scaleX: 1 })}
      {line("left-0 top-0 h-full w-px origin-bottom", { scaleY: 0 }, { scaleY: 1 })}
    </>
  );
};

export const Formula = () => {
  return (
    <section
      data-testid="formula-section"
      className="bg-charcoal py-24 sm:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          variants={staggerParent}
          className="mb-16 max-w-2xl"
        >
          <motion.p variants={revealUp} className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-labyellow">
            02 / THE FORMULA
          </motion.p>
          <motion.h2
            variants={revealUp}
            className="font-display text-3xl leading-[1.05] tracking-tight text-offwhite sm:text-5xl"
          >
            THREE VARIABLES. <span className="text-labyellow">ONE RESULT.</span>
          </motion.h2>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          variants={staggerParent}
          className="grid grid-cols-1 gap-6 md:grid-cols-3"
        >
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.num}
              variants={revealUp}
              className="relative rounded-[3px] p-8 sm:p-10"
              data-testid={`formula-card-${i + 1}`}
            >
              <BorderDraw delay={0.15 + i * 0.12} />
              <span className="font-mono text-5xl font-medium text-labyellow sm:text-6xl">
                {p.num}
              </span>
              <h3 className="mt-6 font-display text-xl uppercase tracking-tight text-offwhite sm:text-2xl">
                {p.title}
              </h3>
              <p className="mt-4 font-body text-sm leading-relaxed text-offwhite/70">
                {p.copy}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
